var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.977 18.5V16.5C10.977 13.7386 8.78814 11.5 6.08811 11.5C3.38805 11.5 1.19922 13.7386 1.19922 16.5V18.5H10.977ZM10.977 18.5H18.7992V17.5C18.7992 14.5545 16.6104 12.5 13.9103 12.5C12.5284 12.5 11.2804 13.1255 10.3912 14.1311M9.02144 5.5C9.02144 7.15685 7.70814 8.5 6.08811 8.5C4.46808 8.5 3.15477 7.15685 3.15477 5.5C3.15477 3.84315 4.46808 2.5 6.08811 2.5C7.70814 2.5 9.02144 3.84315 9.02144 5.5ZM15.8659 7.5C15.8659 8.6046 14.9904 9.5 13.9103 9.5C12.8303 9.5 11.9548 8.6046 11.9548 7.5C11.9548 6.39543 12.8303 5.5 13.9103 5.5C14.9904 5.5 15.8659 6.39543 15.8659 7.5Z",
    fill: "#183059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.977 18.5V16.5C10.977 13.7386 8.78814 11.5 6.08811 11.5C3.38805 11.5 1.19922 13.7386 1.19922 16.5V18.5H10.977ZM10.977 18.5H18.7992V17.5C18.7992 14.5545 16.6104 12.5 13.9103 12.5C12.5284 12.5 11.2804 13.1255 10.3912 14.1311M9.02144 5.5C9.02144 7.15685 7.70814 8.5 6.08811 8.5C4.46808 8.5 3.15477 7.15685 3.15477 5.5C3.15477 3.84315 4.46808 2.5 6.08811 2.5C7.70814 2.5 9.02144 3.84315 9.02144 5.5ZM15.8659 7.5C15.8659 8.6046 14.9904 9.5 13.9103 9.5C12.8303 9.5 11.9548 8.6046 11.9548 7.5C11.9548 6.39543 12.8303 5.5 13.9103 5.5C14.9904 5.5 15.8659 6.39543 15.8659 7.5Z",
    stroke: "#183059",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.b5daf7cb92107a697d114acfac3cbc67.svg";
export { ForwardRef as ReactComponent };